import { useEffect, useMemo, useState } from "react"

export const useDragCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [customCursorEnabled, setCustomCursorEnabled] = useState(false)

  const cursorComponent = useMemo(() => {
    if (!customCursorEnabled) return null
    return (
      <div
        className="pointer-events-none fixed left-0 top-0 z-50 h-[68px] w-[68px] cursor-none"
        style={{
          transform: `translate(${position.x - 34}px, ${position.y - 34}px)`,
        }}>
        <div className="relative h-full w-full cursor-none">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="68"
            height="68"
            viewBox="0 0 68 68"
            className="fill-marketing-primary-light dark:fill-marketing-primary-dark">
            <path
              d="M67.5 33.75C67.5 52.3896 52.3896 67.5 33.75 67.5C15.1104 67.5 0 52.3896 0 33.75C0 15.1104 15.1104 0 33.75 0C52.3896 0 67.5 15.1104 67.5 33.75Z"
              fillOpacity="0.11"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M38.3145 24.9297C38.8849 24.3595 39.8093 24.3595 40.3795 24.9297L48.1672 32.7175C48.7375 33.2877 48.7375 34.2121 48.1672 34.7824L40.3795 42.5701C39.8093 43.1404 38.8849 43.1404 38.3145 42.5701C37.7443 41.9999 37.7443 41.0755 38.3145 40.5052L45.0697 33.7499L38.3145 26.9947C37.7443 26.4245 37.7443 25.4999 38.3145 24.9297Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.1855 42.5703C28.6151 43.1405 27.6907 43.1405 27.1205 42.5703L19.3328 34.7825C18.7625 34.2123 18.7625 33.2879 19.3328 32.7176L27.1205 24.9299C27.6907 24.3596 28.6151 24.3596 29.1855 24.9299C29.7557 25.5001 29.7557 26.4246 29.1855 26.9948L22.4303 33.7501L29.1855 40.5053C29.7557 41.0755 29.7557 42.0001 29.1855 42.5703Z"
            />
          </svg>
        </div>
      </div>
    )
  }, [position, customCursorEnabled])

  useEffect(() => {
    const updatePosition = (e: MouseEvent) => {
      setPosition({ x: e.clientX, y: e.clientY })
    }

    window.addEventListener("mousemove", updatePosition)

    return () => {
      window.removeEventListener("mousemove", updatePosition)
    }
  }, [])

  return { cursorComponent, setCustomCursorEnabled }
}

export const DragCursorWrapper = ({ children }: { children: React.ReactNode }) => {
  const { cursorComponent, setCustomCursorEnabled } = useDragCursor()
  return (
    <div
      className="cursor-none"
      onMouseEnter={() => setCustomCursorEnabled(true)}
      onMouseLeave={() => setCustomCursorEnabled(false)}>
      {children}
      {cursorComponent}
    </div>
  )
}
